import loader from '../moduleLoader.js';

function DownloadPdf (container){

    var trigger;
    
    function init() {
        container.querySelector('.mark-all').addEventListener('click',
            (event) => {
                event.preventDefault();
                var checkboxes = container.querySelectorAll('.section-checkbox');

                for (var i = 0, n = checkboxes.length; i < n; i++) {
                    checkboxes[i].checked = true;
                }
            });
        container.querySelector('.unmark-all').addEventListener('click',
            (event) => {
                event.preventDefault();
                var checkboxes = container.querySelectorAll('.section-checkbox');

                for (var i = 0, n = checkboxes.length; i < n; i++) {
                    checkboxes[i].checked = false;
                }
            });
    }  
    
    return {
        init: init
    }
}

loader.add('DownloadPdf', DownloadPdf);
export default DownloadPdf;
